// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.volume-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 12px;
  width: 100%;
  height: 100%;
}

.volume-chart__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  width: 100%;
}

.volume-chart__title {
  font-weight: 600;
  font-size: 26px;
  line-height: 35px;
  text-align: center;
  color: #000000;
}

.volume-chart__subtitle {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #000000;
  opacity: 0.5;
}

.volume-chart__average {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 4px;
}

.volume-chart__average-label {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #000000;
  opacity: 0.5;
}

.volume-chart__average-value {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #FFA825;
}

.volume-chart__axis-label {
  font-weight: 400;
  font-size: 11px;
  line-height: 14px;
  color: #000000;
  opacity: 0.5;
  text-align: left;
  width: 100%;
  margin-top: 4px;
}

.volume-chart__container {
  width: 100%;
  height: 200px;
  flex: 1;
  min-height: 150px;
}

.volume-chart__footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.volume-chart__footer-left {
  font-weight: 400;
  font-size: 7px;
  line-height: 10px;
  color: #000000;
  opacity: 0.5;
}

.volume-chart__footer-right {
  font-weight: 700;
  font-size: 7px;
  line-height: 10px;
  text-align: right;
  color: #000000;
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/components/chartjs/VolumeChart.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd","sourcesContent":["\n.volume-chart {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 12px;\n  width: 100%;\n  height: 100%;\n}\n\n.volume-chart__header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n}\n\n.volume-chart__title {\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 35px;\n  text-align: center;\n  color: #000000;\n}\n\n.volume-chart__subtitle {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  text-align: center;\n  color: #000000;\n  opacity: 0.5;\n}\n\n.volume-chart__average {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.volume-chart__average-label {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #000000;\n  opacity: 0.5;\n}\n\n.volume-chart__average-value {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  color: #FFA825;\n}\n\n.volume-chart__axis-label {\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 14px;\n  color: #000000;\n  opacity: 0.5;\n  text-align: left;\n  width: 100%;\n  margin-top: 4px;\n}\n\n.volume-chart__container {\n  width: 100%;\n  height: 200px;\n  flex: 1;\n  min-height: 150px;\n}\n\n.volume-chart__footer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n}\n\n.volume-chart__footer-left {\n  font-weight: 400;\n  font-size: 7px;\n  line-height: 10px;\n  color: #000000;\n  opacity: 0.5;\n}\n\n.volume-chart__footer-right {\n  font-weight: 700;\n  font-size: 7px;\n  line-height: 10px;\n  text-align: right;\n  color: #000000;\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
